import { useReactTable, getCoreRowModel, ColumnDef, flexRender, getPaginationRowModel } from '@tanstack/react-table';
import { useMemo, useState } from 'react';
import { QueryClient, QueryClientProvider, useQuery } from 'react-query';
import '../../content-panes/admin-candidate/candidate-listing-table/candidatesTables.css';
import { FaChevronLeft, FaChevronRight, FaStepBackward, FaStepForward } from 'react-icons/fa';
export const ClientUsersTable = ({
    columns,
    data,
    pageIndex,
    pageCount,
    setPageIndex,
}) => {
    const defaultData = useMemo(() => data || [], [data]);
    const defaultColumns = useMemo(() => columns || [], [columns]);

    const table = useReactTable({
        data: defaultData,
        columns: defaultColumns,
        getCoreRowModel: getCoreRowModel(),
        manualPagination: true,
        pageCount: pageCount ?? -1,
        state: {
            pagination: { pageIndex, pageSize: 10 },
        }

    });

    const renderPageNumbers = () => {
        const totalPageCount = pageCount || 1;
        const currentPage = pageIndex + 1;
        const pageNumbers = [];

        pageNumbers.push(1);

        if (totalPageCount > 5) {
            if (currentPage > 3) {
                pageNumbers.push('...');
            }

            const start = Math.max(2, currentPage - 1);
            const end = Math.min(totalPageCount - 1, currentPage + 1);

            for (let i = start; i <= end; i++) {
                pageNumbers.push(i);
            }

            if (currentPage < totalPageCount - 2) {
                pageNumbers.push('...');
            }
            pageNumbers.push(totalPageCount);
        } else {
            for (let i = 2; i <= totalPageCount; i++) {
                pageNumbers.push(i);
            }
        }

        return pageNumbers;
    };

    return (
        <div>
            <div className="table-wrapper">
                <table className="tables">
                    <thead>
                        {table.getHeaderGroups().map((headerGroup) => (
                            <tr key={headerGroup.id}>
                                {headerGroup.headers.map((header) => (
                                    <th key={header.id}>
                                        {header.isPlaceholder ? null : flexRender(header.column.columnDef.header, header.getContext())}
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody>
                        {table.getRowModel().rows.length > 0 ? (
                            table.getRowModel().rows.map((row) => (
                                <tr key={row.id}>
                                    {row.getVisibleCells().map((cell) => (
                                        <td key={cell.id}>
                                            {flexRender(cell.column.columnDef.cell, cell.getContext())}
                                        </td>
                                    ))}
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={columns?.length || 5} className="no-data-container">
                                    No users found
                                </td>
                            </tr>
                        )}

                        {pageCount > 1 && (
                            <tr>
                                <td colSpan={columns?.length || 5}>
                                    <div className="pagination-container">
                                        <button className="border rounded p-1" onClick={() => setPageIndex(0)} disabled={pageIndex === 0}>
                                            <FaStepBackward size={14} />
                                        </button>
                                        <button className="border rounded p-1" onClick={() => setPageIndex(Math.max(pageIndex - 1, 0))} disabled={pageIndex === 0}>
                                            <FaChevronLeft size={14} />
                                        </button>

                                        {renderPageNumbers().map((page, index) => (
                                            <button
                                                key={index}
                                                className={`border rounded p-1 ${typeof page === 'number' && page === pageIndex + 1 ? 'active' : ''}`}
                                                onClick={() => { if (typeof page === 'number') setPageIndex(page - 1); }}
                                                disabled={typeof page !== 'number'}
                                            >
                                                {page}
                                            </button>
                                        ))}

                                        <button
                                            className="border rounded p-1"
                                            onClick={() => setPageIndex(Math.min(pageIndex + 1, pageCount - 1))}
                                            disabled={pageIndex >= pageCount - 1}
                                        >
                                            <FaChevronRight size={14} />
                                        </button>
                                        <button
                                            className="border rounded p-1"
                                            onClick={() => setPageIndex(pageCount - 1)}
                                            disabled={pageIndex >= pageCount - 1}
                                        >
                                            <FaStepForward size={14} />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};